import * as KambiWidgetActions from './action-creators';
import * as KambiWidgetSelectors from './selectors';

export {
  KambiWidgetActions,
  KambiWidgetSelectors
};
